<script setup>
import { onMounted } from 'vue';
import SiteNav from '@/components/site/SiteNav.vue';
import SiteFooter from '@/components/site/SiteFooter.vue';
import BrandLoader from '@/components/site/BrandLoader.vue';
import { initTranslate } from '@/composables/useTranslate';

// Boot the Google Translate widget once and re-apply any saved language.
onMounted(initTranslate);
</script>

<template>
  <div class="site">
    <BrandLoader />
    <SiteNav />
    <router-view />
    <SiteFooter />
  </div>
</template>
